import React from 'react';
import { UnlimitedTagContainer } from './tag.unlimited.styles';

const UnlimitedTag = (): JSX.Element => (
  <UnlimitedTagContainer>
    <span>UNLIMITED</span>
  </UnlimitedTagContainer>
)

export default UnlimitedTag;
